import React, { useEffect, useState } from "react";
import Loader from "../../SharedLayouts/Loader";
import Dots from "../../Icons/Dots";
import { Box } from "@mui/system";
import GridTable from "../../table/gridTable";
import { useDispatch, useSelector } from "react-redux";
import { fetchAllWithdrawalReqs } from "../../../store/actions/withdrawal/fetchAllWithdrawalReqs";
import WithdrawalMenu from "../../menus/WithdrawalMenu";
import ApprovewithdrawalModal from "../../modal/ApproveWithdrawalModal";
import useCurrency from "../../../hooks/useCurrency";
import CancelWithdrawal from "../../modal/CancelWithdrawal";
import { getCurrencySymbol } from "../../../Helper/getCurrencySymbol";
import { getTicketSales } from "../../../store/actions/HWS/getTicketSales";

function TicketTable() {
  const dispatch = useDispatch();

  const [contextMenu, setContextMenu] = useState(null);
  const [selectedRow, setSelectedRow] = useState(null);

  const [selectedWithdrawalId, setSelectedWithdrawalId] = useState(null);

  const [_currency, getAmount] = useCurrency();

  const { pending, ticketSales, ticketSalesInfo } = useSelector(
    (state) => state?.transactions
  );

  const user = useSelector((state) => state.onboarding.user);

  useEffect(() => {
    dispatch(getTicketSales());
  }, [dispatch]);

  const handleContextMenu = (event, params) => {
    event.preventDefault();
    setSelectedRow(params.row);
    setSelectedWithdrawalId(params.row.id);
    if (
      params.row.requestStatus !== "approved" &&
      params.row.requestStatus !== "cancelled"
    ) {
      setContextMenu({
        mouseX: event.clientX - 2,
        mouseY: event.clientY - 4,
      });
    } else {
      setContextMenu(null);
    }
  };

  const columns = [
    {
      field: "ID",
      headerName: "ID",
      renderCell: (params) => params.row?.id,
    },
    {
      field: "userId",
      headerName: "User ID",
      renderCell: (params) => params.row?.user?.id,
    },
    {
      field: "Name",
      headerName: "Name",
      width: 150,
      renderCell: (params) => params.row?.user?.name,
    },

    {
      field: "email",
      headerName: "Email",
      width: 300,
      renderCell: (params) => params.row?.user?.email,
    },
    {
      field: "type",
      headerName: "Type",
      width: 150,
      renderCell: (params) => params.row?.ticket?.name,
    },
    {
      field: "price",
      headerName: "Price",
      width: 150,
      renderCell: (params) =>
        `${getCurrencySymbol(params.row?.currency)} ${getAmount(
          params.row?.ticket?.price,
          2
        )}`,
    },
    {
      field: "quantity",
      headerName: "Quantity",
      width: 150,
      renderCell: (params) => params.row?.quantity,
    },
    {
      field: "amount",
      headerName: "Total Amount",
      width: 150,
      renderCell: (params) =>
        `${getCurrencySymbol(params.row?.currency)} ${getAmount(
          params.row?.total_amount,
          2
        )}`,
    },

    {
      field: "Date",
      headerName: "Date",
      width: 200,
      renderCell: (params) => new Date(params.row?.created_at)?.toDateString(),
    },

    // {
    //   field: "requestStatus",
    //   headerName: "Request Status",
    //   width: 150,
    //   renderCell: (params) => {
    //     const status = params.row?.status;
    //     return (
    //       <div className="flex">
    //         <div
    //           className="px-3 py-0.5"
    //           style={{
    //             borderRadius: "20px",
    //             marginRight: "10px",
    //             color:
    //               status === "cancelled"
    //                 ? "#B42318"
    //                 : status === "processing"
    //                 ? "#9b6700"
    //                 : "green",
    //             backgroundColor:
    //               status === "approved"
    //                 ? "#00800052"
    //                 : status === "Processing"
    //                 ? "#aea22d30"
    //                 : status === "cancelled"
    //                 ? "#f5f0f0"
    //                 : "",
    //           }}
    //         >
    //           {status === "pending"
    //             ? "Pending"
    //             : status === "cancelled"
    //             ? "Cancelled"
    //             : status === "approved"
    //             ? "Approved"
    //             : "Processing"}
    //         </div>
    //       </div>
    //     );
    //   },
    // },
    // {
    //   width: 40,
    //   renderCell: (params) => (
    //     <>
    //       {user?.roles &&
    //         !user?.roles?.some((role) => role.name === "Admin_Tier_1") && (
    //           <div
    //             style={{ cursor: "pointer", position: "relative" }}
    //             onClick={(e) => handleContextMenu(e, params)}
    //           >
    //             <Dots />
    //           </div>
    //         )}
    //     </>
    //   ),
    // },
  ];

  return (
    <div className="mt-10 mb-8">
      <div className="bg-white">
        {!pending ? (
          <Box sx={{ overflowX: "auto", width: "100%", cursor: "pointer" }}>
            <GridTable
              // type={"withdrawal requests"}
              rows={ticketSales}
              noReport
              columns={columns}
              pageInfo={ticketSalesInfo}
              getRowId={(row) => row.id}
              // onRowClick={handleRowClick}
            />
          </Box>
        ) : (
          <Loader />
        )}
      </div>
    </div>
  );
}

export default TicketTable;
